import { WidgetConfiguration } from '../getWidgets/getWidgets.types'

export interface SaveWidgetRequest {
  id?: string
  widget_key: string
  configuration: WidgetConfiguration
  size: string
  display_order: number
  is_collapsed: boolean
}

export interface SaveWidgetsRequest {
  widgets: SaveWidgetRequest[]
}

export interface SaveWidgetsResponse {
  success: boolean
  data: unknown
}
